import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { GestionReferidosComponent } from '../gestion-referidos/gestion-referidos.component';
import { NotificacionDetalle } from '../../../../models/notificacion-detalle.model';
import { NotificacionDetalleService } from '../../../../services/notificacion-detalle/notificacion-detalle.service';
import { NotificacionReferidoService } from '../../../../services/notificacion-referido/notificacion-referido.service'; // AÑADIR

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.css'],
})
export class NotificationDialogComponent {
  usuariosNoMarcados: { [idUsuario: number]: number } = {};
  usuarioEliminado: number | null = null;

  constructor(
    public dialogRef: MatDialogRef<NotificationDialogComponent>,
    private dialog: MatDialog,
    private notificacionDetalleService: NotificacionDetalleService,
    private notificacionReferidoService: NotificacionReferidoService,
    @Inject(MAT_DIALOG_DATA)
    public data: { users: any[]; idNotificacion: number }
  ) {}

  OnReferidosClick(user: any) {
    const idUsuario = Number(user.identificacion.replace(/[^0-9]/g, ''));
    const idNotificacion = user.idNotificacion || this.data.idNotificacion;

    const detalle: NotificacionDetalle = {
      idNotificacion: idNotificacion,
      idUsuario: idUsuario,
    };

    this.notificacionDetalleService.guardar(detalle).subscribe({
      next: (res) => {
        const dialogRef = this.dialog.open(GestionReferidosComponent, {
          width: '350px',
          data: {
            nombre: user.nombre,
            idDetalle: res.idDetalle,
            idUsuario: idUsuario,
            usuariosNoMarcados: this.usuariosNoMarcados,
            idNotificacion: idNotificacion,
          },
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (!result) return;

          const idUsuario = result.idUsuario;
          const contador = result.contador;
          const eliminarUsuario = result.eliminarUsuario;

          this.usuariosNoMarcados[idUsuario] = contador;

          if (eliminarUsuario) {
            // Actualizar visualmente la lista inmediatamente
            this.data.users = this.data.users.filter(
              (u) => u.idNormalizado !== idUsuario
            );
            this.usuarioEliminado = idUsuario;

            // Actualizar estado en backend
            this.notificacionReferidoService
              .actualizarEstado(idNotificacion, false)
              .subscribe({
                next: () => {
                  // Nada adicional, ya se eliminó visualmente
                },
                error: (err) =>
                  console.error('Error actualizando estado:', err),
              });

            // Actualizar sessionStorage
            const eliminados = JSON.parse(
              sessionStorage.getItem('usuariosEliminados') || '[]'
            );
            if (!eliminados.includes(idUsuario)) {
              eliminados.push(idUsuario);
              sessionStorage.setItem(
                'usuariosEliminados',
                JSON.stringify(eliminados)
              );
            }
          }
        });
      },
      error: (err) => console.error('Error guardando detalle', err),
    });
  }

  close(): void {
    this.dialogRef.close({
      usuariosActualizados: this.data.users,
      idNotificacion: this.data.idNotificacion,
      idUsuarioEliminado: this.usuarioEliminado,
      usuariosEliminados: this.usuariosNoMarcados, // Enviar los usuarios marcados
    });
  }
}
